const styles = {
    layout: {
        minHeight: '100vh',
        borderBottomRightRadius: '50px',
        borderTopRightRadius: '50px',
        justifyContent: 'center',
    },
    left_layout: {
        display: 'flex',
        justifyContent: 'space-evenly',
        flexDirection: 'column',
    },
    logo: {
        height: 50,
        width: 180,
    },
    logo_space: { display: 'flex', justifyContent: 'space-evenly', flexDirection: 'column' },
    signIn_bg_img: {
        backgroundImage: 'url(/images/signin_bg.png)',
        backgroundRepeat: 'no-repeat',
        backgroundColor: 'transparent',
        backgroundSize: '100%',
        backgroundPosition: 'center',
        objectFit: 'cover',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
    },
    absolute: {
        position: 'absolute',
        left: 0,
        top: 0,
    },
    image_container: {
        minHeight: '100vh',
        position: 'relative',
        height: '300px',
        width: '100%',
        overflow: 'hidden',
    },
};

export default styles;
